export const parseJsonSafely = <T>(raw: string | null, defaultValue: T, context: string): T => {
  if (!raw) return defaultValue;
  try {
    return JSON.parse(raw) as T;
  } catch (error) {
    console.error(`Failed to parse ${context}:`, error);
    return defaultValue;
  }
};

export const getCleanFilterObj = (filter: Record<string, string>, filterKeysAllow: string[]) =>
  Object.entries(filter || {}).reduce(
    (prev, [key, value]) =>
      filterKeysAllow.includes(key) && ![undefined, null, ''].includes(value) ? { ...prev, [key]: value } : prev,
    {},
  );
